/**
 * @generated SignedSource<<e8fb4e4b20f97b96a2cd8dc061bd0092>>
 * @relayHash 39bc3e9b36d2d26778542ee0ba85f091
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/413.0.0-2023-05-09T14:43:46.011Z/AddressFormRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddressFormRefetchQuery$variables = {
  canCheckZipCode: boolean;
  country?: string | null;
  zipCode?: string | null;
};
export type AddressFormRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AddressForm_viewer">;
  };
};
export type AddressFormRefetchQuery = {
  response: AddressFormRefetchQuery$data;
  variables: AddressFormRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canCheckZipCode"
},
v1 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "country"
},
v2 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "zipCode"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddressFormRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddressForm_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddressFormRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Geography",
            "kind": "LinkedField",
            "name": "geography",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "countries",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "usStates",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "canCheckZipCode",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "zipCodeLookUp",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "country"
                  },
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "zipCode"
                  }
                ],
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "zipCode",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/413.0.0-2023-05-09T14:43:46.011Z/AddressFormRefetchQuery",
    "metadata": {},
    "name": "AddressFormRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1211c1d6892179d98e5e5d742b0c3a30";

export default node;
